import React, { useEffect, useState } from "react";
import { BrowserRouter, Route, Routes, useLocation } from "react-router-dom";
import { Sidebar } from "components";
import TenantDeactivationNotice from "components/tenantDeactivationNotice/tenantDeactivationNotice";
import {
  DashboardPage,
  NoPage,
  ResourcesPage,
  SupportPage,
  UsersPage,
} from "pages";
import TenantContentPage from "pages/tenantContent";
import "./router.scss";
import SettingPage from "pages/settings";
import TenantDomainsPage from "pages/users/domains";
import { useDispatch, useSelector } from "react-redux";
import { setAppActiveItem } from "redux/slices/appSlice";
import { NAVIGATION_ITEM } from "common";
import { selectOrginizationDetails } from "redux/slices/orginizationSlice";
import { getOrginizationinfo } from "redux/slices/orginizationSlice";
import {
  selectDashboardTargetCountry
} from "redux/slices/dashboardSlice"
function MyRoutes() {
  const dispatch = useDispatch();
  const location = useLocation();
  const [loaded, setLoaded] = useState(false);
  const targetCountry = useSelector(selectDashboardTargetCountry);
  const organization = useSelector(selectOrginizationDetails);
  const contentManagementEnabled = Boolean(
    organization?.features?.content_management
  );

  useEffect(() => {
    let type = NAVIGATION_ITEM.HOME;
    switch (location.pathname) {
      case "/users":
      case "/users/domains":
        type = NAVIGATION_ITEM.USERS;
        break;
      case "/content/modules":
        type = NAVIGATION_ITEM.MODULES;
        break;
      case "/content/pathways":
        type = NAVIGATION_ITEM.PATHWAYS;
        break;
      case "/content/programs":
        type = NAVIGATION_ITEM.PROGRAMS;
        break;
      case "/resources":
        type = NAVIGATION_ITEM.RESOURCES;
        break;
      case "/support":
        type = NAVIGATION_ITEM.SUPPORT;
        break;
      case "/settings":
        type = NAVIGATION_ITEM.SETTINGS;
        break;
      default:
        type = NAVIGATION_ITEM.HOME;
        break;
    }
    dispatch(setAppActiveItem(type));
  }, [dispatch, setAppActiveItem, location]);

  useEffect(() => {
    (async () => {
      await dispatch(getOrginizationinfo(targetCountry));
      setLoaded(true);
    })();
  }, []);

  return (
    <div className="router-content">
      <TenantDeactivationNotice />
      {!loaded ? null : (
        <Routes>
          <Route path="/">
            <Route exact path="" element={<DashboardPage />} />
            <Route exact path="home" element={<DashboardPage />} />
            <Route exact path="users" element={<UsersPage />} />
            <Route exact path="users/domains" element={<TenantDomainsPage />} />
            <Route
              path="content/:contentType"
              element={
                contentManagementEnabled ? <TenantContentPage /> : <NoPage />
              }
            />
            <Route exact path="resources" element={<ResourcesPage />} />
            <Route exact path="support" element={<SupportPage />} />
            <Route exact path="settings" element={<SettingPage />} />
            <Route path="*" element={<NoPage />} />
          </Route>
        </Routes>
      )}
    </div>
  );
}

export default function AppRouter() {
  return (
    <BrowserRouter>
      <Sidebar />
      <div className="router-container">
        <MyRoutes />
      </div>
    </BrowserRouter>
  );
}
